<template>
  <el-row>
    <el-form :model="saveClueFollowRemarkForm"
             ref="saveClueFollowRemarkRef"
             :rules="rules"
             @onSelectInfo="onSelectInfo"
             addAction="/clue/saveClueFollow.action"
             editAction="/clue/saveClueFollow.action"
             selectAction="/clue/selectClueDetail.action"
             label-width="150px"
             style="width:50%"
             v-form>
      <el-form-item label="跟进状态："   prop="followStatus">
        <el-select v-model="saveClueFollowRemarkForm.followStatus">
          <el-option label="待跟进" :value="1"></el-option>
          <el-option label="再次跟进" :value="5"></el-option>
          <el-option label="有效线索" :value="2"></el-option>
          <el-option label="无效线索" :value="3"></el-option>
          <el-option label="成交" :value="4"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="跟进备注："  prop="followRemark">
      <el-input type="textarea" placeholder="请输入跟进备注" v-model="saveClueFollowRemarkForm.followRemark"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary">确定</el-button>
        <el-button @click="$router.back()">取消</el-button>
      </el-form-item>
    </el-form>
  </el-row>
</template>

<script>
import BasicPager from '@/mixins/BasicPager'

export default {
  name: 'saveClueFollowRemark',
  extends: BasicPager,
  components: {},
  data: function () {
    return {
      rules: {
        followStatus: [
          { required: true, message: '请输选择跟进状态', trigger: 'blur' }
        ],
        followRemark: [
          { required: true, message: '请输入备注描述', trigger: 'blur' }
        ]
      },
      saveClueFollowRemarkForm: {
        id: null,
        followStatus: null,
        followRemark: null
      }
    }
  },
  created () {
    this.saveClueFollowRemarkForm.id = this.$route.query.id
  },
  methods: {
    onFilterParams: function (params) {
    },
    onSelectInfo: function (dataInfo) {
    }
  },
  filters: {}

}
</script>

<style scoped>

</style>
